module.exports = __webpack_public_path__ + "img/tourBanner.a37831d6.png";